import React from "react";
import ReactDOM from "react-dom";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
/* eslint import/no-webpack-loader-syntax: off */
import "!style-loader!css-loader!./index.css";
import App from "./components/App";
import authReducer from "./store/auth/reducer";
import analyticsReducer from "./store/analytics/reducer";
import webStorageManager from "./services/managers/web-storage";
import { STORAGE_KEY_USER_INFO } from "./services/managers/constants";
import registerServiceWorker from "./registerServiceWorker";

// Combine multiple redux reducers
const reducer = combineReducers({
  auth: authReducer,
  analytics: analyticsReducer
});

// Redux DevTools Extension
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Compose multiple redux enhancers
const enhancer = composeEnhancers(applyMiddleware(thunk));

// Create a redux store
const store = createStore(reducer, enhancer);

if (window.location.protocol === "https:" && window.navigator.serviceWorker) {
  // Service worker to serve assets from local cache
  // Provided with create-react-app by default
  registerServiceWorker();
}

//Removed the login based logic for time being
window.addEventListener(
  "load",
  function() {
    webStorageManager.set(STORAGE_KEY_USER_INFO, { source: "hardcoded", userId: "default", userName: "default" });
    ReactDOM.render(
              <Provider store={store}>
                <App />
              </Provider>,
              document.getElementById("root")
            );});

// Listen to incoming message from the CMEGroup.com website
// Load React app only if incoming message has required values
//window.addEventListener(
//  "message",
//  function(event) {
//    console.log("INCOMING MESSAGE", event.data);
//    if (event.data && typeof event.data === "object" && event.data.source && event.data.source.toLowerCase() === "cme") {
//      if (
//        typeof event.data.userId === "string" &&
//        event.data.userId.trim().length &&
//        typeof window.APP_ENV === "object" &&
//        typeof window.APP_ENV.API_BASE_URL === "string"
//      ) {
//        // Cache user info received from CMEGroup.com for later use
//        webStorageManager.set(STORAGE_KEY_USER_INFO, { source: event.data.source, userId: event.data.userId, userName: event.data.userName });
//        ReactDOM.render(
//          <Provider store={store}>
//            <App />
//          </Provider>,
//          document.getElementById("root")
//        );
//      } else {
////        console.log("Adding user details as default user");
////        webStorageManager.set(STORAGE_KEY_USER_INFO, { source: "hardcoded", userId: "default", userName: "default" });
////                ReactDOM.render(
////                  <Provider store={store}>
////                    <App />
////                  </Provider>,
////                  document.getElementById("root")
////                );
//        ReactDOM.render(<div>Encountered a problem while loading. Please refresh the page</div>, document.getElementById("root"));
//      }
//    }
//  },
//  false
//);

// For informational/debugging purpose only
console.log("WINDOW.LOCATION", window.location);
console.log("WINDOW.APP_ENV", window.APP_ENV);
console.log("debug message");


// WEBPACK FOOTER //
// ./src/index.js